import { IConnectionConfig } from "./types";

export function getUrlParam(
    param: string,
): string | null {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get(param);
}

export function getConnectionData(): IConnectionConfig {
    const data = {
        playerSessionId: getUrlParam('playerSessionId') || "",
        server: getUrlParam("server") || "",
        gameId: getUrlParam("gameId") || "",
        accountType: getUrlParam("accountType") || ""
    }

    if (!data.playerSessionId) {
        throw Error('Parameter [playerSessionId] not present in url: ' + window.location.href);
    }
    if (!data.server) {
        throw Error('Parameter [server] not present in url: ' + window.location.href);
    }
    if (!data.gameId) {
        throw Error('Parameter [gameId] not present in url: ' + window.location.href);
    }
    if (!data.accountType) {
        throw Error('Parameter [accountType] not present in url: ' + window.location.href);
    }
    console.debug('Connection data: ', { data });
    return data;
}
